import { get as getAppState, set as setAppState } from '@hotjar/webapp/domains/common/app-state';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import { getParameter } from '@hotjar/insights-common/lib/url';

const NAMESPACE = 'survey_templates';
const SURVEY_TEMPLATE_ID = 'survey_template_id';

export const setSurveyTemplateIdToAppState = (
  userId: number,
  siteId: number,
  surveyTemplateId: string,
): Promise<ApiBaseResponse> => {
  const targeting = { siteId };
  const scopedKeyValue = { namespace: NAMESPACE, key: SURVEY_TEMPLATE_ID, value: surveyTemplateId };
  return setAppState(userId, scopedKeyValue, targeting);
};

const getSurveyTemplateIdFromUrl = (): string | null => {
  return getParameter(window.location.href, SURVEY_TEMPLATE_ID) || null;
};

export const getSurveyTemplateIdFromAppState = (
  userId: number,
  siteId: number,
): Promise<{ templateId: string | null }> => {
  const targeting = { siteId };

  return getAppState(userId, targeting)
    .then((state) => {
      const templateId = state[NAMESPACE] && state[NAMESPACE][SURVEY_TEMPLATE_ID];
      return { templateId: templateId || null };
    })
    .catch(() => ({ templateId: null }));
};

export const getSurveyTemplateId = async (
  userId: number,
  siteId: number,
): Promise<{ templateId: string | null }> => {
  const templateId = getSurveyTemplateIdFromUrl();
  if (!templateId) {
    return getSurveyTemplateIdFromAppState(userId, siteId);
  }
  return { templateId };
};
